import type { Document } from '@/types'

/** Base URL of the Sumit web app (app.sumit.co.il), where CRM documents live. */
export const SUMIT_APP_BASE_URL = 'https://app.sumit.co.il'

/**
 * Build the direct link to a document's Sumit CRM page (HQ-858), of the form
 * `https://app.sumit.co.il/f<folder>/c<docid>/`, where <folder> is the CRM
 * expenses-folder id and <docid> is the CRM entity (card) id.
 *
 * Reads the dedicated `sumit_folder_id` / `sumit_document_id` columns, falling
 * back to the ids the sync keeps in `extracted_metadata` (folder was not always
 * persisted per document before the HQ-858 migration). Returns `null` when the
 * mapping is incomplete — nothing to link to.
 */
export function getSumitDocumentUrl(document: Document): string | null {
  const meta = (document.extracted_metadata ?? {}) as Record<string, unknown>

  const folder =
    document.sumit_folder_id ?? (meta.sumit_folder_id as string | undefined)
  const docId =
    document.sumit_document_id ?? (meta.sumit_entity_id as string | undefined)

  if (!folder || !docId) return null

  return `${SUMIT_APP_BASE_URL}/f${folder}/c${docId}/`
}
